export default __webpack_public_path__ + "static/media/work-learn.hospitality-management.8e2eb1e7.png";